import { connect } from "react-redux";
import { VzPageContainer } from "../../../../layouts/VzPageContainer";
import { Col, Row, Container, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { changePassword } from "./ChangePasswordActions";
import FormikControl from "../../../../layouts/Input/FormikControl";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import history, { logout } from "../../../../history";
import { signOut } from "../../../Login/AuthAction";
import { toast } from "react-toastify";

const ChangePassword = (props) => {
  const [isMatch, setIsMatch] = useState(false);
  const [realValueOldPassword, setRealValueOldPassword] = useState("");
  const [realValueNewPassword, setRealValueNewPassword] = useState("");
  const [realValueConfirmPassword, setRealValueConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const profileInitialValues = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const [currentEntity, setCurrentEntity] = useState(profileInitialValues);

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Old password is required"),

    newPassword: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-zA-Z]/, "Password must contain letters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&#^()_+\-=\[\]{};':"\\|,.<>\/?]/,
        "Password must contain at least one special character"
      ),

    confirmPassword: Yup.string().required("Confirm password is required"),
    // .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  });

  const handleSubmit = async (data) => {
    if (currentEntity.newPassword !== currentEntity.confirmPassword) {
      toast.info("Confirm Password Not Match");
      return;
    }

    const request = {
      oldPassword: currentEntity?.oldPassword || "",
      newPassword: currentEntity?.newPassword || "",
      confirmPassword: currentEntity?.confirmPassword || "",
    };

    props.changePassword(request);
  };

  const handleBackBtn = async (data) => {
    history.push("/dashboard");
    history.go("/dashboard");
  };

  const PasswordMatchWatcher = ({ setIsMatch }) => {
    const { values } = useFormikContext();

    useEffect(() => {
      const passwordsMatch =
        values.newPassword &&
        values.confirmPassword &&
        values.newPassword === values.confirmPassword;

      setIsMatch(passwordsMatch);
    }, [values.newPassword, values.confirmPassword, setIsMatch]);

    return null; // No UI needed
  };

  const handleChange = (e, password) => {
    const input = e.target.value;
    const prev =
      password == "old"
        ? currentEntity.oldPassword
        : password == "new"
        ? currentEntity.newPassword
        : currentEntity.confirmPassword;

    // Detect if user is adding or deleting
    if (input.length > prev.length) {
      // Append last character typed
      const newChar = input[input.length - 1];

      if (password == "old")
        setCurrentEntity({ ...currentEntity, oldPassword: prev + newChar });
      else if (password == "new")
        setCurrentEntity({ ...currentEntity, newPassword: prev + newChar });
      else
        setCurrentEntity({ ...currentEntity, confirmPassword: prev + newChar });
    } else {
      // Remove last character

      if (password == "old")
        setCurrentEntity({
          ...currentEntity,
          oldPassword: prev.slice(0, input.length),
        });
      else if (password == "new")
        setCurrentEntity({
          ...currentEntity,
          newPassword: prev.slice(0, input.length),
        });
      else
        setCurrentEntity({
          ...currentEntity,
          confirmPassword: prev.slice(0, input.length),
        });
    }
  };

  return (
    <div>
      <VzPageContainer title="Change Password">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Change Password</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ float: "left" }}>
            <Formik
              enableReinitialize
              initialValues={currentEntity}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autoComplete="off">
                  <PasswordMatchWatcher setIsMatch={setIsMatch} />
                  <Container>
                    <Row>
                      <Col md={8}>
                        <Row className="align-items-center">
                          <Col xs={3} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Old Password</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="oldPassword"
                                value={
                                  !showPassword
                                    ? "*".repeat(
                                        currentEntity.oldPassword.length
                                      )
                                    : currentEntity.oldPassword
                                }
                                onChange={(e) => handleChange(e, "old")}
                                onPaste={(e) => e.preventDefault()} // prevent paste
                                onCopy={(e) => e.preventDefault()} // prevent copy
                                onCut={(e) => e.preventDefault()} // prevent cut
                                style={{ letterSpacing: "2px" }}
                              />
                            </div>
                          </Col>
                          <Col xs={3}>
                            {!showPassword ? (
                              <i
                                class="fas fa-eye"
                                style={{ marginBottom: "22px" }}
                                onClick={() => setShowPassword(true)}
                              ></i>
                            ) : (
                              <i
                                class="fas fa-eye-slash"
                                style={{ marginBottom: "22px" }}
                                onClick={() => setShowPassword(false)}
                              ></i>
                            )}
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={3} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">New Password</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="newPassword"
                                value={
                                  !showPassword
                                    ? "*".repeat(
                                        currentEntity.newPassword.length
                                      )
                                    : currentEntity.newPassword
                                }
                                onChange={(e) => handleChange(e, "new")}
                                onPaste={(e) => e.preventDefault()} // prevent paste
                                onCopy={(e) => e.preventDefault()} // prevent copy
                                onCut={(e) => e.preventDefault()} // prevent cut
                                style={{ letterSpacing: "2px" }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center">
                          <Col xs={3} className="d-flex align-items-center">
                            <div className="form-group">
                              <label className="mb-0">Confirm Password</label>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                name="confirmPassword"
                                value={
                                  !showPassword
                                    ? "*".repeat(
                                        currentEntity.confirmPassword.length
                                      )
                                    : currentEntity.confirmPassword
                                }
                                onChange={(e) => handleChange(e, "confirm")}
                                onPaste={(e) => e.preventDefault()} // prevent paste
                                onCopy={(e) => e.preventDefault()} // prevent copy
                                onCut={(e) => e.preventDefault()} // prevent cut
                                style={{ letterSpacing: "2px" }}
                              />
                            </div>
                          </Col>
                          <Col xs={3}>
                            {isMatch &&
                            currentEntity.confirmPassword.length > 1 ? (
                              <i
                                className="fas fa-check"
                                style={{ color: "green" }}
                              ></i>
                            ) : !isMatch &&
                              currentEntity.confirmPassword.length > 1 ? (
                              <i
                                className="fas fa-times"
                                style={{ color: "red" }}
                              ></i>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row style={{ float: "right" }}>
                      <Col md={12}>
                        <Button
                          className="btn btn-default"
                          style={{ width: "100px", marginRight: "5px" }}
                          onClick={handleBackBtn}
                        >
                          Back
                        </Button>
                        <Button
                          type="submit"
                          className="btn btn-primary"
                          style={{ width: "100px" }}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    PasswordReset: state.PasswordReset ? state.PasswordReset : {},
  };
};

export default connect(mapStateToProps, {
  changePassword,
  signOut,
})(ChangePassword);
